import BDiaryDayMealSearch from "./BDiaryDayMealSearch";
import BDiaryDaySearch from "./BDiaryDaySearch";

export default class BDiaryDaySearchFactory
{
	static construct(el)
	{
		if (el.classList.contains("profile-diary-day-meal-search")) {
			return new BDiaryDayMealSearch(el);
		}

		return new BDiaryDaySearch(el);
	}
}
